import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWindowSize } from 'react-use';
import { Box, Grid, TextField, useTheme } from '@mui/material';

import { BuildingList, CrystalButton, Loading } from 'components';
import { ROUTES } from 'consts';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppDispatch, useAppSelector } from 'store/store.hook';
import { useBuildingItems } from './buildings.hook';
import { updateLayout } from 'store/slices/layout.slice';

interface BuildingsPageProps {}

export const BuildingsPage: React.FC<BuildingsPageProps> = () => {
  const dispatch = useAppDispatch();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [searchKeyword, setSearchKeyword] = React.useState<string>('');
  const [loading, buildingItems] = useBuildingItems({ searchKeyword });
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const theme = useTheme();

  useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'Buildings' }));
  }, []);

  const openAddBuilding = () => {
    setTimeout(() => {
      navigate(`/${orgSlug}/${ROUTES.BUILDINGS}/new`);
    }, 500);
  };

  return loading ? (
    <Loading text="Loading buildings..." height={400} />
  ) : (
    <Box sx={{ padding: 3 }}>
      <Grid container rowSpacing={5} columnSpacing={3}>
        <Grid
          item
          xs={12}
          container
          spacing={2}
          alignItems={width < theme.breakpoints.values.md ? 'center' : 'flex-start'}
        >
          <Grid item sx={{ flex: 1 }}>
            <TextField
              label="Search Buildings"
              autoComplete="off"
              placeholder="Enter search keyword..."
              size="small"
              fullWidth
              InputProps={{ sx: { bgcolor: 'white' } }}
              onChange={(event) => setSearchKeyword(event.target.value)}
              sx={{ maxWidth: width < theme.breakpoints.values.md ? 345 : 480 }}
            />
          </Grid>

          <Grid item>
            <CrystalButton onClick={openAddBuilding} />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <BuildingList
            buildings={buildingItems}
            onBuildingItem={(buildingId) => {
              navigate(`/${orgSlug}/${ROUTES.BUILDINGS}/${buildingId}`);
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
